import React, { useEffect, useImperativeHandle, useState } from 'react';
import FieldError from '../../../../../shared/fields-errors/field-error';
import { Button, Form, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { GET_DEFAULT_PAYMENT_PROCESSOR, SET_DEFAULT_PAYMENT_PROCESSOR } from '../../../../../constants/endpoints';

const DefaultPaymentProcessorDialog = React.forwardRef((props,ref) => {
    //props 
    const [show, setShow] = useState(false);
    const [requestLoader, setRequestLoader] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const { register, reset, handleSubmit, formState: {errors} } = useForm({
        defaultValues:{
            default_payment_processor: ""
        }
    });

    //methods
    useImperativeHandle(ref, () => {
        return {
            handleShow: handleShow,
        };
    });

    const handleShow = () => {
        setShow(true);
        getDefaultPaymentProcessor();
    }

    const handleClose = () => {
        setErrorMessage("");
        setShow(false);
    }

    const saveDefaultPaymentProcessor = (formValues) => {
        setErrorMessage("");
        setRequestLoader(true);
        axios.patch(SET_DEFAULT_PAYMENT_PROCESSOR, formValues)
            .then((res) => {
                setRequestLoader(false);
                if (res?.data.status) {
                    handleClose();
                }else{
                    setErrorMessage(res?.data?.message);
                }
            }).catch((error) => {
                setRequestLoader(false);
                setErrorMessage("Failed to save settings.");
            })
    }

    const getDefaultPaymentProcessor = () => {
        setRequestLoader(true);
        axios.get(GET_DEFAULT_PAYMENT_PROCESSOR)
        .then((res) => {
            setRequestLoader(false);
            if(res?.data.status){
                reset(res?.data?.response);
            }
        }).catch((error) => {
            setRequestLoader(false);
        })
    }

    return (
        <Modal
            keyboard={false}
            backdrop="static" show={show} onHide={handleClose} animation={true}>
            <Form onSubmit={handleSubmit(saveDefaultPaymentProcessor)}>
                <Modal.Header closeButton>
                    <Modal.Title>Set Default Payment Processor</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" >
                        <Form.Label>Payment Processor</Form.Label>
                        <Form.Select
                            {...register('default_payment_processor', {
                                validate: {
                                    required: value => {
                                        if (!value) return 'Field is required.';
                                        return true;
                                    }
                                }
                            })} >
                                <option value={'Stripe'}>Stripe</option>
                                <option value={'Square'}>Square</option>
                            </Form.Select>
                        {errors?.default_payment_processor ? <FieldError message={errors?.default_payment_processor?.message} /> : ''}
                    </Form.Group>
                    {errorMessage ? <p className='text-danger'>{errorMessage}</p> : ""}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="default" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button disabled={requestLoader} type='submit' variant="primary"
                        className={`${requestLoader ? 'position-relative button--loading' : ''}`}>
                        Save
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
});

export default DefaultPaymentProcessorDialog;